import { Action, createReducer, on } from "@ngrx/store";
import { AgencyPageActions } from "./actions";
import { State } from "./state";

const initalState: State = {
  policyAgencies: [],
};

const agencyReducer = createReducer(
  initalState,
  on(AgencyPageActions.clearAgencies, (state, action): State => {
    return {
      policyAgencies: [],
    };
  }),
  on(AgencyPageActions.setAgencies, (state, action): State => {
    return {
      policyAgencies: [...action.agencies]?.sort((a, b) =>
        a.name > b.name ? 1 : -1
      ),
    };
  }),
  on(AgencyPageActions.setAgenciesFeatureState, (state, action): State => {
    return action.state;
  })
);

export function reducer(state: State | undefined, action: Action) {
  return agencyReducer(state, action);
}
